import React, {Fragment, useEffect, useState} from 'react'
import {Checkbox, Col, Form, Input, Message, message, Modal, Row, Select, Space, Switch, TimePicker} from 'antd'
import {getCategories, getCommodities, getStores} from '../../../api/businessCommodity'
import {fetchPackageDetail, postEditPackage, postNewPackage} from '../../../api/package'
import {CloseCircleFilled, PlusCircleFilled} from '@ant-design/icons'
import moment from 'moment'

const PackageForm = (props) => {
    const [name, setName] = useState('')
    const [amount, setAmount] = useState('')
    const [duration, setDuration] = useState('')
    const [storeList, setStoreList] = useState([])
    const [categoryList, setCategoryList] = useState([])
    const [warnBeforeTimeout, setWarnBeforeTimeout] = useState(false)
    const [limitedTime, setLimitedTime] = useState(false)
    const [commodities, setCommodities] = useState([])
    const [isAutomaticPostpaid, setIsAutomaticPostpaid] = useState(false)
    const [isCommodityInstantlyCheckout, setIsCommodityInstantlyCheckout] = useState(true)
    const [needFlashingReminder, setNeedFlashingReminder] = useState(false)
    const [needWechatReminder, setNeedWechatReminder] = useState(false)
    const [purchaseTime, setPurchaseTime] = useState([moment('00:00', 'HH:mm'), moment('00:00', 'HH:mm')])
    const [purchaseWeekday, setPurchaseWeekday] = useState(127)
    const [isEnabled, setIsEnabled] = useState(true)
    const [weekDays, setWeekDays] = useState([1, 2, 3, 4, 5, 6, 7])
    const [reservation, setReservation] = useState({isEnabled: false})

    const weekOptions = [
        {label: '周一', value: 1},
        {label: '周二', value: 2},
        {label: '周三', value: 3},
        {label: '周四', value: 4},
        {label: '周五', value: 5},
        {label: '周六', value: 6},
        {label: '周日', value: 7},
    ]

    useEffect(() => {
        getStoreList()
        getCategoryList()
        if (props.id) {
            getPackageDetail(props.id)
        }
    }, [props.id])

    const getPackageDetail = async (id) => {
        const {data, status, detail} = await fetchPackageDetail({id})
        if (status !== 1) {
            Message.error(detail)
            return
        }

        let gifts = []
        if (data.commodityGifts.length > 0) {
            for (let i = 0; i < data.commodityGifts.length; i++) {
                let gift = {}
                const datas = await getCommodities(data.commodityGifts[i].store.id, data.commodityGifts[i].category.id)
                gift.commodityList = datas.data
                gift.storeId = data.commodityGifts[i].store.id
                gift.categoryId = data.commodityGifts[i].category.id
                gift.commodityId = data.commodityGifts[i].commodity.id
                gift.quantity = data.commodityGifts[i].quantity
                gift.disabled = false
                gifts.push(gift)
            }
        }

        const week = data.purchaseWeekday.toString(2).split('').reverse()
        let purchaseWeekday = []
        week.forEach((item, index) => {
            if (item === '1') {
                purchaseWeekday.push(index + 1)
            }
        })

        setName(data.name)
        setAmount((data.amount / 100).toFixed(2))
        setDuration((data.duration / 60).toFixed(0))
        setPurchaseTime([moment(data.purchaseStartTime, 'HH:mm'), moment(data.purchaseEndTime, 'HH:mm')])
        setWeekDays(purchaseWeekday)
        setIsEnabled(data.isEnabled)
        setLimitedTime(data.isPurchaseLimitEnabled)
        setIsAutomaticPostpaid(data.isAutomaticPostpaid)
        setIsCommodityInstantlyCheckout(data.isCommodityInstantlyCheckout)
        setNeedFlashingReminder(data.needFlashingReminder)
        setNeedWechatReminder(data.needWechatReminder)
        setWarnBeforeTimeout(data.needFlashingReminder || data.needWechatReminder)
        setCommodities(gifts)
        setReservation(data.reservation)
    }

    const getStoreList = async () => {
        const {data, detail, status} = await getStores()
        if (status !== 1) {
            Message.error(detail)
            return
        }
        setStoreList(data)
    }

    const getCategoryList = async () => {
        const club_id = sessionStorage.getItem('club_id')
        const {data, detail, status} = await getCategories(club_id)
        if (status !== 1) {
            Message.error(detail)
            return
        }
        setCategoryList(data)
    }

    const getCommodityList = async (index) => {
        const {data, detail, status} = await getCommodities(commodities[index].storeId, commodities[index].categoryId)
        if (status !== 1) {
            Message.error(detail)
            return
        }
        let newCommodities = [...commodities]
        newCommodities[index].commodityList = data
        setCommodities(newCommodities)
    }

    const commoditySelect = (index, key, value) => {
        let newCommodities = [...commodities]
        newCommodities[index][key] = value
        if (key === 'storeId') {
            newCommodities[index].categoryId = ''
            newCommodities[index].commodityId = ''
            newCommodities[index].quantity = ''
            newCommodities[index].disabled = true
        }
        if (key === 'categoryId') {
            newCommodities[index].commodityId = ''
            newCommodities[index].quantity = ''
            newCommodities[index].disabled = false
        }
        if (key === 'commodityId') {
            newCommodities[index].quantity = ''
        }
        setCommodities(newCommodities)
        if (key === 'categoryId') {
            getCommodityList(index)
        }
    }

    const addCommodity = () => {
        const commodity = {
            storeId: '',
            categoryId: '',
            commodityId: '',
            quantity: '',
            commodityList: [],
            disabled: true,
        }
        setCommodities([...commodities, commodity])
    }

    const removeCommodity = (index) => {
        let newCommodities = [...commodities]
        if (newCommodities.length >= 1) {
            newCommodities.splice(index, 1)
        } else {
            newCommodities = [
                {
                    storeId: '',
                    categoryId: '',
                    commodityId: '',
                    quantity: '',
                    commodityList: [],
                    disabled: true,
                },
            ]
        }
        setCommodities(newCommodities)
    }

    const weekOnchange = (value) => {
        const week = []
        weekOptions.forEach((item) => {
            if (value.includes(item.value)) {
                week.push(1)
            } else {
                week.push(0)
            }
        })
        setWeekDays(value)
        setPurchaseWeekday(parseInt(week.reverse().join(''), 2))
    }

    const handleOk = async () => {
        if (!(name && amount && duration)) {
            Message.error('请完整填写信息')
            return
        }
        for (let i = 0; i < commodities.length; i++) {
            if (!(commodities[i].storeId && commodities[i].categoryId && commodities[i].commodityId && commodities[i].quantity)) {
                Message.error('请完整填写信息')
                return
            }
        }
        if (reservation.isEnabled && duration % 30 !== 0) {
            message.error('套餐时长不是30分钟的整数倍，不允许选择开启预定')
            return
        }

        let prepaid = {
            clubId: sessionStorage.getItem('club_id'),
            name,
            amount: (amount * 100).toFixed(0),
            duration: (duration * 60).toFixed(0),
            purchaseWeekday,
            isPurchaseLimitEnabled: limitedTime,
            isAutomaticPostpaid,
            isCommodityInstantlyCheckout,
            needFlashingReminder,
            needWechatReminder,
        }
        if (limitedTime) {
            prepaid.purchaseStartTime = purchaseTime.length === 2 ? purchaseTime[0].format('HH:mm') : ''
            prepaid.purchaseEndTime = purchaseTime.length === 2 ? purchaseTime[1].format('HH:mm') : ''
        }

        let commodityGifts = commodities.map((item) => ({
            id: props.id ? props.id : -1,
            quantity: item.quantity,
            store: {id: item.storeId},
            category: {id: item.categoryId},
            commodity: {id: item.commodityId},
        }))

        let params = {prepaid, commodityGifts, reservation}

        if (props.record) {
            params.tableEnabled = {
                tableId: props.record.table_id,
                isEnabled,
            }
        }

        if (!props.id) {
            const {data, status, detail} = await postNewPackage([params])
            if (status !== 1) {
                Message.error(detail)
                return
            }
            Message.success('操作成功')
            props.updatePackageView()
            props.handleCancelPackage()
        } else {
            params.prepaid.id = props.id
            const {data, status, detail} = await postEditPackage([params])
            if (status !== 1) {
                Message.error(detail)
                return
            }
            Message.success('操作成功')
            props.updatePackageView()
            props.handleCancelPackage()
        }
    }

    const onSwitchChange = (value, key) => {
        if (key === 'isAutomaticPostpaid' && !value) {
            setIsCommodityInstantlyCheckout(true)
        }
        if (key === 'isAutomaticPostpaid') {
            setIsAutomaticPostpaid(value)
        }
    }

    const onCheckboxChange = (e, key) => {
        if (key === 'needFlashingReminder') {
            setNeedFlashingReminder(e.target.checked)
        }
        if (key === 'needWechatReminder') {
            setNeedWechatReminder(e.target.checked)
        }
    }

    const onChangePurchaseTime = (moment, time) => {
        setPurchaseTime(moment)
    }

    const handleOpenReservation = async (checked) => {
        if (!reservation.isEnabled && duration % 30 !== 0) {
            message.error('套餐时长不是30分钟的整数倍，不允许选择开启预定')
            return
        }
        setReservation({isEnabled: checked})
    }

    return (
        <div>
            <Modal
                title={props.id ? '编辑套餐' : '新建套餐'}
                visible={props.visible}
                onOk={handleOk}
                onCancel={props.handleCancelPackage}
                width={1000}
            >
                <Form labelCol={{span: 5}}>
                    <Form.Item label="套餐名">
                        <Input style={{width: 200}} onChange={(e) => setName(e.target.value)} value={name}/>
                    </Form.Item>

                    <Form.Item label="价格（元）">
                        <Input style={{width: 200}} onChange={(e) => setAmount(e.target.value)} value={amount}/>
                    </Form.Item>

                    <Form.Item label="时长（分钟）">
                        <Input style={{width: 200}} onChange={(e) => setDuration(e.target.value)} value={duration}/>
                    </Form.Item>

                    <Form.Item label="允许预订">
                        <Space>
                            <Form.Item noStyle>
                                <Switch onChange={handleOpenReservation}
                                        checked={reservation ? reservation.isEnabled : false}/>
                            </Form.Item>
                            <div style={{color: "red"}}>注:预订套餐不含赠送商品</div>
                        </Space>
                    </Form.Item>

                    <Form.Item label="赠送商品">
                        {commodities.length === 0 && (
                            <PlusCircleFilled
                                style={{fontSize: '16px', marginLeft: '20px', color: '#2D8CFF'}}
                                onClick={addCommodity}
                            />
                        )}

                        {commodities.length > 0 &&
                            commodities.map((item, index) => (
                                <div style={{marginBottom: '10px'}} key={index}>
                                    <Select
                                        className="mr-20"
                                        style={{width: 120}}
                                        onChange={(value) => commoditySelect(index, 'storeId', value)}
                                        value={item.storeId}
                                    >
                                        <Select.Option value="">选择仓库</Select.Option>
                                        {storeList.length > 0 &&
                                            storeList.map((store) => (
                                                <Select.Option value={store.id} key={store.id}>
                                                    {store.name}
                                                </Select.Option>
                                            ))}
                                    </Select>

                                    <Select
                                        className="mr-20"
                                        style={{width: 120}}
                                        onChange={(value) => commoditySelect(index, 'categoryId', value)}
                                        value={item.categoryId}
                                    >
                                        <Select.Option value="">选择类型</Select.Option>
                                        {categoryList.length > 0 &&
                                            categoryList.map((category) => (
                                                <Select.Option value={category.id} key={category.id}>
                                                    {category.name}
                                                </Select.Option>
                                            ))}
                                    </Select>

                                    <Select
                                        className="mr-20"
                                        style={{width: 120}}
                                        onChange={(value) => commoditySelect(index, 'commodityId', value)}
                                        value={item.commodityId}
                                        disabled={item.disabled}
                                    >
                                        <Select.Option value="">选择商品</Select.Option>
                                        {item.commodityList.length > 0 &&
                                            item.commodityList.map((commodity) => (
                                                <Select.Option value={commodity.id} key={commodity.id}>
                                                    {commodity.name}
                                                </Select.Option>
                                            ))}
                                    </Select>

                                    <Input
                                        style={{width: 120}}
                                        placeholder="输入数量"
                                        onChange={(e) => commoditySelect(index, 'quantity', e.target.value)}
                                        value={item.quantity}
                                    />

                                    {commodities.length >= 1 && (
                                        <CloseCircleFilled
                                            style={{fontSize: '16px', marginLeft: '20px'}}
                                            onClick={() => removeCommodity(index)}
                                        />
                                    )}

                                    {commodities.length === index + 1 && (
                                        <PlusCircleFilled
                                            style={{fontSize: '16px', marginLeft: '20px', color: '#2D8CFF'}}
                                            onClick={addCommodity}
                                        />
                                    )}
                                </div>
                            ))}
                    </Form.Item>

                    <Form.Item label="限时购买">
                        <Row gutter={8}>
                            <Col span={3}>
                                <Form.Item>
                                    <Switch onChange={setLimitedTime} checked={limitedTime}/>
                                </Form.Item>
                            </Col>

                            {limitedTime && (
                                <Fragment>
                                    <Col span={10}>
                                        <Form.Item label="时间限制">
                                            <TimePicker.RangePicker
                                                format="HH:mm"
                                                style={{width: 200}}
                                                value={purchaseTime}
                                                onChange={onChangePurchaseTime}
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col span={10}>
                                        <Form.Item>
                                            <div style={{marginTop: '5px'}}>
                                                <Checkbox.Group value={weekDays} options={weekOptions}
                                                                onChange={weekOnchange}/>
                                            </div>
                                        </Form.Item>
                                    </Col>
                                </Fragment>
                            )}
                        </Row>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    )
}

export default PackageForm


// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/newPackageModal.js